import React from 'react';

const SvgCreatedBy: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="-6 -6 24 24" fill="none" {...props}>
    <path
      d="M6 6C6.79565 6 7.55871 5.68393 8.12132 5.12132C8.68393 4.55871 9 3.79565 9 3C9 2.20435 8.68393 1.44129 8.12132
      0.87868C7.55871 0.316071 6.79565 0 6 0C5.20435 0 4.44129 0.316071 3.87868 0.87868C3.31607 1.44129 3 2.20435 3 3C3
      3.79565 3.31607 4.55871 3.87868 5.12132C4.44129 5.68393 5.20435 6 6 6ZM6.263 7.508C4.215 7.433 0 8.453 0
      10.5V12H6.405C5.25 10.5 6.234 7.583 6.263 7.508Z"
      fill="#373B40"
    />
    <path
      d="M5.643 7.5041C7.692 7.4291 11.91 8.4501 11.91 10.4991V12.0001H5.5C5.5 10.0001 5.673 7.5791 5.643 7.5041Z"
      fill="#373B40"
    />
  </svg>
);

export default SvgCreatedBy;
